import React from 'react';

import Icon from 'src/components/Common/Icon';
import classNames from 'classnames';

interface TimelineItemProps {
  /** Description of the Item. */
  children: React.ReactNode;
  /** CSS class name */
  className?: string;
  /** Color of the whole item. */
  color?: string;
  /** Date the item occurred. */
  date: string;
  /** Headline of the item. */
  header?: React.ReactNode;
  /** Icon that is shown on the literal timeline. */
  icon: string;
  /** Number of the item in the timeline written out as string. E.g. one. */
  number: string;
}

const TimelineItem = ({
  children,
  className,
  color,
  date,
  header,
  icon,
  number,
}: TimelineItemProps) => (
  <div className={classNames(className, `ce-timeline-item ${color} ${number}`)}>
    <div className="ce-timeline-icon is-hidden">
      <Icon name={icon} />
    </div>

    <div className="ce-timeline-content is-hidden">
      <div className="text-wrapper">
        <div className="ce-timeline-date">{date}</div>
        {header}
        {children}
      </div>
    </div>
  </div>
);

TimelineItem.defaultProps = {
  color: 'gray',
  className: null,
  header: null,
};

export default TimelineItem;
